import { Col, Row } from "react-bootstrap"
import { Modal } from "../../Modal"
import * as S from "./styled"
import { resume } from "../../../i18n/pt.json"
import { mountRedirect } from "../../../utils/redirect.service"

function Web({ urls, isntSurfacado, order, handleDelete }) {
  return (
    <Col xs={0} lg={4} className="d-lg-block">
      <S.OrderSummary className="w-100">
        <S.Resumo>
          <S.Redirect>
            <S.Title>{resume.title}</S.Title>
            <S.Text>
              {resume.quantity}
              <S.Quantity>{order.qtyItens}</S.Quantity>
            </S.Text>
            <S.Text style={{ border: 0 }}>
              {resume.total}
              <S.Total>{order.total}</S.Total>
            </S.Text>

            <Modal checkoutModal props={{ type: order.type }} />

            {isntSurfacado && (
              <a onClick={mountRedirect(urls.type)}>
                <S.HollowButton className="btnResumo">
                  <S.ButtonText>{resume.keepbuying}</S.ButtonText>
                </S.HollowButton>
              </a>
            )}
          </S.Redirect>

          <Modal fn={handleDelete} deleteModal isResume />
        </S.Resumo>
      </S.OrderSummary>
    </Col>
  )
}

function Mobile({ urls, isntSurfacado, order, handleDelete }) {
  return (
    <Col xs={0} lg={4} className="d-lg-block">
      <S.OrderSummary className="w-100">
        <S.Resumo className="mobile">
          <S.Redirect>
            <S.Title className="mobile">{resume.title}</S.Title>
            <S.Text className="mobile">
              {resume.quantity}
              <S.Quantity>{order.qtyItens}</S.Quantity>
            </S.Text>
            <S.Text style={{ border: 0 }}>
              {resume.total}
              <S.Total>{order.total}</S.Total>
            </S.Text>

            <Modal checkoutModal props={{ type: order.type }} />

            {isntSurfacado && (
              <a onClick={mountRedirect(urls.type)}>
                <S.HollowButton className="btnResumo">
                  <S.ButtonText>{resume.keepbuying}</S.ButtonText>
                </S.HollowButton>
              </a>
            )}
          </S.Redirect>

          <Modal fn={handleDelete} deleteModal isResume />
        </S.Resumo>
      </S.OrderSummary>
    </Col>
  )
}

export default function Layout(props) {
  const { isMobile } = props

  return isMobile ? <Mobile {...props} /> : <Web {...props} />
}
